/**
 * Judge.me widget restyle — aggressive fallback strategy.
 * Instead of relying on exact class names (which vary across Judge.me
 * versions), we (a) hide any element in the widget's container that
 * doesn't contain the write-review button, and (b) find the write
 * button by its VISIBLE TEXT (widget_open_form_text = "Escribir una
 * reseña" per jdgmSettings) and force-style it with inline !important.
 */
(function () {
  // Hide the Judge.me default heading ("Deja que los clientes hablen por
  // nosotros" / "Let customers speak for us!") wherever it appears.
  try {
    var s = document.createElement('style');
    s.setAttribute('data-jdgm-hide-title', '1');
    s.textContent =
      '.jdgm-rev-widg__title,' +
      '.jdgm-widget__title,' +
      '.jdgm-rev-widg__header-title,' +
      '.jdgm-all-reviews__title,' +
      '.jdgm-all-reviews-widget__title,' +
      '.jdgm-all-reviews-page__title,' +
      '.jdgm-rev-widg h2.jdgm-rev-widg__title,' +
      '.jdgm-rev-widg h2 { display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important; }';
    (document.head || document.documentElement).appendChild(s);
  } catch (e) { /* noop */ }

  var BTN_TEXTS = ['Escribir una reseña', 'Write a review', 'Escribir una reseña.'];

  var BTN_STYLES = {
    'display': 'inline-block',
    'margin': '0',
    'padding': '14px 28px',
    'background': '#ccf985',
    'background-color': '#ccf985',
    'background-image': 'none',
    'color': '#000',
    'border': 'none',
    'border-radius': '999px',
    'font-family': 'var(--font-body--family)',
    'font-size': '12px',
    'font-weight': '500',
    'letter-spacing': '0.08em',
    'text-transform': 'uppercase',
    'text-decoration': 'none',
    'cursor': 'pointer',
    'box-shadow': 'none'
  };

  function findButtons() {
    var out = [];
    // 1) Any known Judge.me button class
    document.querySelectorAll('.jdgm-write-rev-link, .jdgm-write-review-btn, [class*="write-rev-link"]').forEach(function (el) { out.push(el); });
    // 2) Any anchor/button whose text matches
    document.querySelectorAll('a, button').forEach(function (el) {
      var txt = (el.textContent || '').trim();
      if (BTN_TEXTS.indexOf(txt) !== -1) out.push(el);
    });
    return out;
  }

  function findWidgetContainer(btn) {
    // Climb up until we hit the OUTERMOST jdgm widget container so we
    // catch title/summary elements that live in sibling branches of
    // the button's immediate parent.
    var el = btn;
    var last = null;
    for (var i = 0; i < 20 && el; i++) {
      var cls = (typeof el.className === 'string') ? el.className : '';
      if (/\bjdgm-/.test(cls)) last = el;
      el = el.parentElement;
    }
    return last;
  }

  function isEnglish() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') === 0) return true;
    return /^\/en(\/|$)/.test(window.location.pathname);
  }

  function localizedLabel() {
    return isEnglish() ? 'Write a review' : 'Escribir una reseña';
  }

  var TITLE_TEXTS = [
    'Deja que los clientes hablen por nosotros',
    'Deja que los clientes hablen por nosotros.',
    'Let customers speak for us',
    'Let customers speak for us!'
  ];

  function hideDefaultTitles() {
    document.querySelectorAll('h1, h2, h3, h4, .jdgm-rev-widg__title, [class*="jdgm"][class*="title"]').forEach(function (el) {
      var txt = (el.textContent || '').trim().replace(/\s+/g, ' ');
      if (TITLE_TEXTS.indexOf(txt) !== -1 || /deja que los clientes hablen por nosotros/i.test(txt) || /let customers speak for us/i.test(txt)) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function apply() {
    try {
      hideDefaultTitles();
      var btns = findButtons();
      var label = localizedLabel();
      btns.forEach(function (btn) {
        Object.keys(BTN_STYLES).forEach(function (prop) {
          btn.style.setProperty(prop, BTN_STYLES[prop], 'important');
        });
        if ((btn.textContent || '').trim() !== label) {
          btn.textContent = label;
        }
        btn.dataset.jdgmRestyled = '1';

        // Hide every sibling of the button inside the widget container.
        var container = findWidgetContainer(btn);
        if (!container) return;
        Array.from(container.querySelectorAll('*')).forEach(function (el) {
          if (el === btn) return;
          if (el.contains(btn)) return; // ancestor of btn — keep visible
          if (btn.contains(el)) return; // inside the button itself
          // Preserve the form wrapper (the modal) and its descendants
          if (el.closest('.jdgm-form-wrapper, .jdgm-quest-answ-form-wrapper')) return;
          el.style.setProperty('display', 'none', 'important');
        });
      });
    } catch (e) { /* noop */ }
  }

  function init() {
    apply();
    var observer = new MutationObserver(function () {
      // Debounce a tiny bit with requestAnimationFrame to avoid ping-pong
      window.requestAnimationFrame(apply);
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    // Also periodic re-apply as a safety net for the first few seconds
    var tries = 0;
    var iv = setInterval(function () {
      apply();
      if (++tries > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
